import { FormattedMessage } from 'react-intl';

import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { LabelXS } from '@sorare/core/src/atoms/typography';
import { StatIcon } from '@sorare/core/src/components/stats/StatIcon';
import { playerUnavailability } from '@sorare/core/src/lib/glossary';

type Props = {
  iconOnly?: boolean;
};

export const BenchExtraSuspension = ({ iconOnly }: Props) => {
  return (
    <Horizontal gap={0.5} center>
      <StatIcon statKey="red_card" size={1.5} />
      {!iconOnly && (
        <LabelXS>
          <FormattedMessage {...playerUnavailability.suspendedTitle} />
        </LabelXS>
      )}
    </Horizontal>
  );
};
